export default __webpack_public_path__ + "static/media/sweatdress.a416fb16.jpg";